export default {
  install(Vue) {
    // 防重复点击(指令实现)
    Vue.directive('drag', {
      inserted(el, binding) {
        let firstTime = 0
        el.addEventListener('mousedown', (e) => {

          var flag = binding.value.getFlag();
          binding.value.setFlag(true)
          // flag = !flag;
          var disx = e.pageX - el.offsetLeft;
          var disy = e.pageY - el.offsetTop;
          document.onmousemove = function (e) {
            // var xx = e.pageX - disx + 'px';
            var xx = el.offsetLeft+'px';
            let move_yy= e.pageY - disy
            if (move_yy<=3){
              move_yy = 3
            }
            if (e.pageY + 60 >= window.innerHeight){
              return
            }
            var yy = move_yy + 'px'
            el.style.left = xx;
            el.style.top = yy;


            binding.value.setXY(xx, yy)

          };
          // if (!flag) {
          //   document.onmousemove = document.onmouseup = null;
          // }
          // binding.value.setFlag(flag);

          firstTime = new Date().getTime()

        })
        document.addEventListener("mouseup",()=>{
            binding.value.setFlag(false);
            document.onmousemove = null
            document.onmouseup = null
        })

        el.addEventListener('mouseup', (e) => {



          binding.value.setFlag(false);
          binding.value.setForbidClick(true)
          const lastTime = new Date().getTime()
          let last = lastTime - firstTime
          if (last < 200) {
            binding.value.setForbidClick(false)
          }
          document.onmousemove = null
          document.onmouseup = null


        })

      }


    })
  }
}



// WEBPACK FOOTER //
// ./src/common/drag.js